import type { IMasterDataProductCategoryRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataProductCategoryDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataProductCategoryUseCase {
  private readonly repository: IMasterDataProductCategoryRepository;

  constructor(repository: IMasterDataProductCategoryRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataProductCategoryDTO) {
    return this.repository.createProductCategory(params);
  }
}
